<div class="flex">
    <h4 data-testid="order-editor-title">Заявка {{order.data.id}}</h4>
    @if (order.data.id) {
        <button mat-flat-button class="w-40" color="primary" type="button" (click)="orderLogs()">Журнал изменений заявки</button>
    }
</div>
@if (loading()) {
    <app-loader [isLoading]="loading()"/>
} @else {
    <form class="flex-column" [formGroup]="orderForm" (ngSubmit)="onSubmit(true)">
        @if(order.data.id) {
            <span>Контактные данные:</span>
        }
        <mat-card class="p-relative" style="margin-bottom: 20px">
            <mat-card-header>
                @if(order.data.id) {
                    <mat-card-title>
                        @if (order.data.contact) {
                            {{order.data.contact.firstName}} {{order.data.contact.lastName}}
                        }
                    </mat-card-title>
                } @else {
                    <div class="flex w-100">
                        <app-person-selector class="w-100" [formCtrl]="orderForm.controls.contactId" [label]="'Заказчик'" [additionalParams]="customerAdditionalParams"/>
                        <div class="flex a-center contact-icon">
                            <mat-icon matTooltip="Создать контакт" (click)="editContact()">person_add</mat-icon>
                        </div>
                    </div>
                }

            </mat-card-header>
            <mat-card-content>
                @if(order.data.id) {
                    <p>Номер телефона:
                        @if (order.data.contact) {
                            {{order.data.contact.phone}}
                        }
                    </p>
                }

                <div class="flex w-100" formArrayName="locationId">
                    <app-common-dropdown class="w-100" [label]="'Адрес'" [service]="locationSelectorService" [formCtrl]="orderForm.controls.locationId" data-testid="app-dropdown-location-order-editor"/>
                    <div class="flex a-center contact-icon" data-testid="add-new-location-button">
                        <mat-icon matTooltip="Создать новый" (click)="addNewLocation()">add_home</mat-icon>
                    </div>
                </div>

                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Полный адрес</mat-label>
                    <input matInput formControlName="addressDetails" />
                </mat-form-field>

            </mat-card-content>
            @if(order.data.id) {
                <mat-card-actions class="p-absolute" style="right: 0; top: 0">
                    <mat-icon matTooltip="Редактировать контакт" (click)="editContact()">edit</mat-icon>
                </mat-card-actions>
            }

        </mat-card>

        <span>Период выполнения:</span>
        <mat-form-field>
            <app-common-date-range
                [dateRange]="dateRange"
                (dateRangeChanged)="changeDate($event)"
            />
            <app-common-date-range-errors [form]="orderForm"/>
        </mat-form-field>

        @if(order.data.id) {
            <mat-form-field appearance="outline">
                <mat-label>Дополнительная информация</mat-label>
                <textarea matInput formControlName="additionalInfo"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Описание</mat-label>
                <input matInput formControlName="description" />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Договор</mat-label>
                <input matInput formControlName="agreement" />
            </mat-form-field>
        }

        <app-common-dropdown
            [label]="'Проект'"
            [formCtrl]="orderForm.controls.projectId"
            [service]="projectSelectorService"
            data-testid="app-dropdown-project-order-editor"
        ></app-common-dropdown>

        <app-common-dropdown
            [label]="'Группа'"
            [formCtrl]="orderForm.controls.groupId"
            [service]="groupsSelectorService"
            data-testid="app-dropdown-group-order-editor"
        ></app-common-dropdown>

        @if(order.data.id) {
            @if (orderForm.controls.groupId.value) {
                <app-person-selector [formCtrl]="orderForm.controls.executorId" [label]="'Работник'" [additionalParams]="executorAdditionalParams"></app-person-selector>
            }

            <span>Запланированные работы:</span>
            <div class="mrt-0-5 mrb-1" formArrayName="orderPrices">
                @for (control of orderForm.controls.orderPrices.controls; track control; let i = $index) {
                    <mat-card>
                        <mat-card-content>
                            <div class="flex">
                                <app-order-price-form class="w-100" [formGroup]="control" [discountControl]="orderForm.controls.discount"></app-order-price-form>
                                <button class="mrt-0-5" mat-icon-button (click)="removeOrderPrice(i)" type="button">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                <button type="button" mat-button [disabled]="!orderForm.controls.orderPrices.valid" (click)="addOrderPrice()">Добавить работу</button>
            </div>

            <mat-checkbox formControlName="discount">
                Применить скидку
            </mat-checkbox>

            <mat-form-field appearance="outline">
                <mat-label>Общая сумма</mat-label>
                <input matInput [value]="totalCostValue" readonly/>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Предоплата</mat-label>
                <input matInput formControlName="prepayment" type="number" readonly/>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Полученная оплата</mat-label>
                <input matInput formControlName="amountPaid" type="number" min="0" step="1"/>
            </mat-form-field>

            @if (orderForm.controls.projectId.value) {
                <app-order-custom-fields [customFieldsParamsControl]="orderForm.controls.customFieldsParams" [projectId]="orderForm.controls.projectId.value"></app-order-custom-fields>
            }

            @if (orderForm.controls.amountPaid.hasError('amountPaidMustBeZero')) {
                <mat-error>
                    Предоплата внесена полностью.
                </mat-error>
            }
            @if (orderForm.controls.amountPaid.hasError('amountPaidExceedsTotal')) {
                <mat-error>
                    Сумма оплачено не может превышать общую стоимость.
                </mat-error>
            }

            <mat-checkbox formControlName="conditionsCheck">
                Проверка наличия тяги в дымовых и вентиляционных каналах, Состояния соединительных труб с
                дымовым каналом: тяга есть, соединения дымоотводящих труб с дымовым каналом
                герметичны. Инструктаж потребителей газа по безопасному пользованию газом при
                удовлетворении коммунально-бытовых нужд проведен, копия инструктажа вручена.
            </mat-checkbox>

            @if (order.data.files) {
                <span>Ссылки на ранее прикрепленные фото/видео:</span>
                @for (file of order.data.files; track file; let i = $index) {
                    <a [href]="fileUrls[i]" [download]="file.name + '.' + file.format">
                        {{file.name}}.{{file.format}}
                    </a>
                }
            }

            <div class="mrt-1 flex-column">
                <span>Подпись заказчика</span>
                <app-signature-pad  class="mrt-0-5" [formCtrl]="orderForm.controls.signature"></app-signature-pad>
            </div>

            @if (order.data.status === OrderStatusEnum.reject) {
                <mat-form-field appearance="outline">
                    <mat-label>Причина отказа</mat-label>
                    <input matInput readonly formControlName="rejectReason" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Описание отказа</mat-label>
                    <textarea matInput readonly formControlName="rejectDescription" ></textarea>
                </mat-form-field>
            }

            <mat-form-field>
                <mat-label>Статус заявки</mat-label>
                <mat-select formControlName="status">
                    @for (status of enumService.enumTranslateStatusToArrSelects(OrderStatusEnum); track status.value) {
                        <mat-option [value]="status.value">{{status.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        <div class="flex justify-between">
            <button mat-stroked-button class="w-40" color="basic" type="button" [disabled]="!order.data.id" (click)="deleteOrder(order.data.id)">Удалить</button>
            <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="orderForm.invalid || loading()" data-testid="save-order-editor-button">Сохранить</button>
        </div>

    </form>
}
